export default [
  {
    className: 'input-wrapper',
    htmlFor: 'first-name',
    html: 'First Name',
    placeholder: 'Update your first name',
    name: 'firstName',
    type: 'text'
  },
  {
    className: 'input-wrapper',
    htmlFor: 'last-name',
    html: 'Last Name',
    placeholder: 'Update your last name',
    name: 'lastName',
    type: 'text'
  },
  {
    className: 'input-wrapper',
    htmlFor: 'phone',
    html: 'Phone',
    placeholder: 'Update your phone number',
    name: 'phone',
    type: 'number'
  }
];
